import { styled, Switch } from '@mui/material';

export const StyledPinkSwitch = styled(Switch)(theme => ({}));
